import styled, { css } from 'styled-components';
import { AnchorButton } from 'src/components/core/button';

export const CtaButtonStyles = css`
  background-color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
  display: inline-block;
  font-size: 13px;
  padding: 12px 24px;
  width: 100%;
`;

export const LogoWrapper = styled.div<{ $showError: boolean }>`
  align-items: center;
  border-radius: 50%;
  display: flex;
  height: ${({ $showError }) => ($showError ? 'auto' : '72px')};
  justify-content: center;
  margin-inline: auto;
  margin-block: ${({ $showError }) => ($showError ? `0 16px` : `10px 25px`)};
  overflow: hidden;
  width: ${({ $showError }) => ($showError ? 'auto' : '72px')};
`;

export const LoyaltyLogo = styled.img`
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;
`;

export const ContentHeader = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Content = styled.div<{ narrow?: boolean }>`
  max-width: ${({ narrow }) => (narrow ? '360px' : '390px')};
  margin: 0 auto;
  width: 100%;
`;

export const Heading = styled.h1`
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  margin: 0 0 10px 0;
`;

export const Description = styled.p`
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  white-space: pre-line;
`;

export const FormWrapper = styled.div`
  text-align: left;
  width: 100%;

  button {
    font-weight: 600;
  }

  button[type='submit'] {
    background-color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
    max-width: 190px;
    width: 100%;
  }
`;

export const BackButton = styled.button`
  align-items: center;
  appearance: none;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.grey[30]};
  cursor: pointer;
  display: flex;
  font-size: 14px;
  font-weight: 600;
  gap: 8px;
  padding: 0;
`;

export const ShopNowButton = styled(AnchorButton)`
  ${CtaButtonStyles}

  &:last-child {
    margin-bottom: 10px;
  }
`;

export const FooterText = styled.p`
  color: ${({ theme }) => theme.colors.grey[30]};
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  text-align: center;
`;

export const FooterLink = styled.a`
  background: none;
  border: none;
  color: ${({ theme }) => theme.customized?.colors?.buttonsLinks ?? theme.colors.primaryBlue};
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  padding: 0;
  text-align: center;
  width: 100%;

  &:hover {
    text-decoration: underline;
  }
`;
